/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { AccountSearch } from '../../modules/accounts/AccountSearch'

const DashboardPage: FC = () => (
  <>
    {/* begin::Row */}

    <div className='row gy-5 g-xl-8'>
      <div className='col-xxl-12'>
        <AccountSearch className='card-xxl-stretch' />
      </div>
    </div>
    {/* end::Row */}
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.TITLE' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
